import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as ngswal from "sweetalert";
import { ApiMethod } from '../../apimethods/api-method';
import { DataParam, customfunctions } from '../../common/customfunctions';
import { GlobalConstants } from '../../common/global-constants';
import { VendorMasterModel } from './vendormaster-model';
declare var $;

@Component({
  selector: 'app-vendor-master',
  templateUrl: './vendor-master.component.html',
  styleUrls: ['./vendor-master.component.css']
})
/** vendor-master component*/
export class VendorMasterComponent implements OnInit {

  modelItem = new VendorMasterModel();

  @ViewChild('dataTable', { static: false }) table;
  dataTable: any;
  dataSet: any;
  title: string;
  popUpButtonText: string;
  showModal: boolean;
  public publisherList: any;
  public sourceList: any;
  public languageList: any;
  public interestList: any;
  public restrictionList: any;
  public journalList: any;
  public taskList: any;
  public CountryList: any;
  public StateList: any;
  public CityList: any;
  StateIDPop: any;
  CityidPop: number;
    status: boolean;


  ngOnInit() {
    ApiMethod.getBaseUrl();
  }

  constructor(private router: Router) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <VendorMasterModel>data["VendorMasterPage"];

        localStorage.aEID = 0;

        $('#ddlActive').select2({
          placeholder: "Select Active Status",
          dropdownParent: "#myModal"
        });
        $('#ddlAvaliable').select2({
          placeholder: "Select Active Status",
          dropdownParent: "#myModal"
        });
        $('#ddlPublisherList').select2({
          placeholder: "Select Publisher",
          dropdownParent: "#myModal"
        });
        $('#ddlPublisherList').val([]).trigger('change');

        $('#ddlSourceList').select2({
          placeholder: "Select Source",
          dropdownParent: "#myModal"
        });
        $('#ddlSourceList').val([]).trigger('change');

        $('#ddlSourceListSer').select2({
          placeholder: "Select Source",
          dropdownParent: "#myModal"
        });
        $('#ddlSourceListSer').val([]).trigger('change');

        $('#ddlLanguageList').select2({
          placeholder: "Select Language",
          dropdownParent: "#myModal"
        });
        $('#ddlLanguageList').val([]).trigger('change');

        $('#ddlLanguageListSer').select2({
          placeholder: "Select Language",
          dropdownParent: "#myModal"
        });
        $('#ddlLanguageListSer').val([]).trigger('change');


        $('#ddlInterestList').select2({
          placeholder: "Select interest",
          dropdownParent: "#myModal"
        });
        $('#ddlInterestList').val([]).trigger('change');

        $('#ddlRestrictionList').select2({
          placeholder: "Select Restriction",
          dropdownParent: "#myModal"
        });
        $('#ddlRestrictionList').val([]).trigger('change');

        $('#ddlTaskList').select2({
          placeholder: "Select Task",
          dropdownParent: "#taskDetails"
        });
        $('#ddlTaskList').val([]).trigger('change');

        $('#ddlTaskListser').select2({
          placeholder: "Select Task",
          dropdownParent: "#divServices"
        });
        $('#ddlTaskListser').val([]).trigger('change');


        $('#ddlJournalList').select2({
          placeholder: "Select Journal",
          dropdownParent: "#myModal"
        });
        $('#ddlJournalList').val([]).trigger('change');

        $('#ddlvendortype').select2({
          placeholder: "Select Vendor Type",
          dropdownParent: "#divServices"
        });
        $('#ddlvendortype').val([]).trigger('change');


        $('#ddlJournal').select2({
          placeholder: "Select Journal",
          dropdownParent: "#myModal"
        });
        $('#ddlJournal').val([]).trigger('change');

        $('#ddlCapacityDuration').select2({
          placeholder: "Select Duration",
          dropdownParent: "#myModal"
        });
        $('#ddlCapacityDuration').val([]).trigger('change');


        $('#ddlCapacityMode').select2({
          placeholder: "Select CapacityMode",
          dropdownParent: "#myModal"
        });
        $('#ddlCapacityMode').val([]).trigger('change');


        $('#ddlCapacityModeSer').select2({
          placeholder: "Select CapacityMode",
          dropdownParent: "#myModal"
        });
        $('#ddlCapacityModeSer').val([]).trigger('change');

        $('#ddlCapacityUnit').select2({
          placeholder: "Select CapacityUnit",
          dropdownParent: "#myModal"
        });
        $('#ddlCapacityUnit').val([]).trigger('change');


        $('#ddlCapacityUnitSer').select2({
          placeholder: "Select CapacityUnit",
          dropdownParent: "#myModal"
        });
        $('#ddlCapacityUnitSer').val([]).trigger('change');

        $('#ddlPriceType').select2({
          placeholder: "Select PriceType",
          dropdownParent: "#myModal"
        });
        $('#ddlPriceType').val([]).trigger('change');

        $('#ddlJournalListService').select2({
          placeholder: "Select Journal",
          dropdownParent: "#myModal"
        });
        $('#ddlJournalListService').val([]).trigger('change');


        /*$('#ddlCountry').select2({ placeholder: "Select Country", dropdownParent: "#myModal" });
        $('#ddlState').select2({ placeholder: "Select State", dropdownParent: "#myModal" });
        $('#ddlCity').select2({ placeholder: "Select City", dropdownParent: "#myModal" });*/


        this.GetPublisherList();
        this.GetInterestList();
        this.GetLanguageList();
        this.GetRestrictionList();
        this.GetJournalList();
        this.GetSourceList();
        this.GetTaskList();
        this.GetVendorList();
        this.GetCountryList();

      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  //EmailID validation
  emailidOnly(event): boolean {
    var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    if (!filter.test(event.currentTarget.value)) {
      event.currentTarget.value = '';
      return ngswal("Warning !", "Invalid Email ID!", "warning");
    }
    return true;

  }

  //Multiple Email Id validation
  MultipleEmail(event) {
    let Worngmailcount = 0;
    let str = event.currentTarget.value;
    let arr = str.split(/[;,]/);
    let filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    let validEmails = [];
    for (let i = 0; i < arr.length; i++) {
      let email = arr[i].trim();
      if (!filter.test(email)) {
        Worngmailcount++;
        continue;
      }
      else {
        validEmails.push(email);
      }
    }
    event.currentTarget.value = validEmails.join(";");
    if (Worngmailcount > 0) {
      ngswal("Warning !", "Please Check Email ID!", "warning");
    }
    this.checkJournal(event.currentTarget.value);

  }
  checkJournal(searchValue) {
    $("#LoadingImage").show();

    var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    if (!filter.test(searchValue)) {
      searchValue = "";
      $("#LoadingImage").hide();
      return ngswal("Warning !", "email not valid", "warning");
    }
    var EmailID;

    if (searchValue == "")
      EmailID = $("#Txt_EmailID").val()
    else
      EmailID = searchValue;


    var FreelancerData = {
      EmailID: EmailID,
    };

    ApiMethod.postMethod(this.modelItem.VendorEmailcheckDuplicate, FreelancerData).subscribe(
      response => {
        $("#LoadingImage").hide();

        if (response.status == "duplicate") {
          this.status = true;
          $("#txtTitle").val("");
          ngswal("Failed !", response.message, "error");
          return this.status;
        }
        else {
          this.status = false;
          return this.status;
        }
      }, error => {
        $("#LoadingImage").hide();

        ngswal("Failed !", error.error.Message, "error");
      });
    return this.status;
  }

  //Get All Countries list
  GetCountryList(): void {
    ApiMethod.getMethod(this.modelItem.CountryListAPI).subscribe(
      result => {
        this.CountryList = result.aCountryList;

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get State by Country
  GetState(StateID = 0, CityID = 0): void {
    ApiMethod.getMethod(this.modelItem.StateListAPI + $('#ddlCountry').val()).subscribe(
      result => {

        $("#ddlState").val(0).change();
        $("#ddlCity").val(0).change();

        this.StateList = result.aStateList;
        this.StateIDPop = StateID;
        if (CityID > 0) {
          this.GetCity(StateID, CityID);
          this.CityidPop = CityID;
        }


      },
      error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  //Get City by State
  GetCity(StateID = 0, CityID = 0): void {
    let nstateId = $('#ddlState').val();
    if (nstateId == null) {
      nstateId = StateID;
    }

    ApiMethod.getMethod(this.modelItem.CityListAPI + nstateId).subscribe(
      result => {
        this.CityList = result.aCityList;
        this.CityidPop = CityID;
      },
      error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  //Get All publisher list
  GetPublisherList(): void {
    ApiMethod.getMethod(this.modelItem.PublisherListAPI).subscribe(
      result => {
        this.publisherList = result.aPublisherList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get All source list
  GetSourceList(): void {
    ApiMethod.getMethod(this.modelItem.SourceListAPI).subscribe(
      result => {
        this.sourceList = result.aSourceList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get All Language list
  GetLanguageList(): void {
    ApiMethod.getMethod(this.modelItem.LanguageListAPI).subscribe(
      result => {
        this.languageList = result.aLanguageList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get All Interest list
  GetInterestList(): void {
    ApiMethod.getMethod(this.modelItem.InterestListAPI).subscribe(
      result => {
        this.interestList = result.aInterestList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get All restriction list
  GetRestrictionList(): void {
    ApiMethod.getMethod(this.modelItem.InterestListAPI).subscribe(
      result => {
        this.restrictionList = result.aInterestList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get All task list
  GetTaskList(): void {
    ApiMethod.getMethod(this.modelItem.TaskListAPI).subscribe(
      result => {
        this.taskList = result.aTaskList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Add Row for Service Details
  AddServiceTaskRow() {

    if ($('#ddlTaskListser').val() == null) {
      ngswal("Failed !", "Please select task", "warning");
      $('#ddlTaskListser').focus();
      return false;
    }
    var zChkValSer = true;
    var dlValSer = $("#ddlTaskListser option:selected").text();
    var taskExistser = false;
    $.each($("#tblTaskSer tbody tr"), function (e) {
      var zPreValSer = $(this).find('td')[1].innerText;
      if (zPreValSer == dlValSer) {
        taskExistser = true;
        return false;
      }
    });
    if ($('#ddlJournalListService').val().toString() == "") {
      ngswal("Failed !", "Please select Journal", "warning");
      $('#ddlJournalListService').focus();
      return false;
    }
    if ($('#ddlLanguageListSer').val().toString() == '') {
      ngswal("Failed !", "Please select Language", "warning");
      $('#ddlLanguageListSer').focus();
      return false;
    }
    if ($('#ddlSourceListSer').val().toString() == '') {
      ngswal("Failed !", "Please select Source", "warning");
      $('#ddlSourceListSer').focus();
      return false;
    }
    if (taskExistser) {
      ngswal("Failed !", "Already task added", "warning");
      zChkValSer = false;
    } else {

      var zRowLenth = $("#tblTaskSer tbody").find("tr").length;
      //Selected Journal display with comma
      var selectedJournal = [];
      $('#ddlJournalListService option:selected').each(function () {
        selectedJournal.push($(this).text());
      });
      var selectedJournalText = selectedJournal.join(',');

      //Selected Language display with comma
      var selectedLanguage = [];
      $('#ddlLanguageListSer option:selected').each(function () {
        selectedLanguage.push($(this).text());
      });
      var selectedLanguageText = selectedLanguage.join(',');

      //Selected Source display with comma
      var selectedSource = [];
      $('#ddlSourceListSer option:selected').each(function () {
        selectedSource.push($(this).text());
      });
      var selectedSourceText = selectedSource.join(',');

      var nRowL = "<tr><td style='width:2%;text-align:center'>" + (zRowLenth + 1).toString() + "</td>"
        + "<td style='width:6%'>" + $('#ddlTaskListser option:selected').text() + "</td>"
        + "<td style='width:6%'>" + selectedJournalText + "</td>"
        + "<td style='width:6%'>" + $('#ddlvendortype option:selected').text() + "</td>"
        + "<td style='width:6%'>" + selectedLanguageText + "</td>"
        + "<td style='width:6%'>" + selectedSourceText + "</td>"
        + "<td><input type='text' class='form-control IsNumeric CC' value='0'/></td>"
        + "<td><input type='text' class='form-control IsNumeric CU' value='0'/></td>"
        + "<td><input type='text' class='form-control IsNumeric CM' value='0'/></td>"
        + "<td width='8%' style='text-align:center'><i class='bx bxs-trash DeleteTaskSerRow' style='color: #f46a6a; font-size: 20px;cursor:Pointer;'></i></td>"
        + "</tr>";
      $("#tblTaskSer tbody").append(nRowL);

      $('#ddlTaskListser').val(-1).change();
      this.ResetServicesFilter();
    }
    $('.DeleteTaskSerRow').click(function () {
      $(this).closest("tr").remove();
      $("table#tblTaskSer tbody").each(function () {
        $(this).children().each(function (index) {
          $(this).find("td").first().html((index + 1).toString());
        });
      });
    });
    //Disable Table values          
    const event = { target: { checked: $('#JournalWisecapacity').prop('checked') } };
    this.disableTableFields(event);
    
  }


  //Add Row for task/Pricing Details
  AddTaskRow() {
    if ($('#ddlTaskList').val() == null) {
      ngswal("Failed !", "Please select task", "warning");
      $('#ddlTaskList').focus();
      return false;
    }

    var zChkVal = true;
    var dlVal = $("#ddlTaskList option:selected").text();
    var taskExists = false;
    $.each($("#tblTask tbody tr"), function (e) {
      var zPreVal = $(this).find('td')[1].innerText;
      if (zPreVal == dlVal) {
        taskExists = true;
        return false;
      }
    });
    if ($('#ddlJournal').val().toString() == '') {
      ngswal("Failed !", "Please select Journal", "warning");
      $('#ddlJournal').focus();
      return false;
    }
    if ($('#ddlPriceType').val() == null) {
      ngswal("Failed !", "Please select PriceType", "warning");
      $('#ddlPriceType').focus();
      return false;
    }
    if (taskExists) {
      ngswal("Failed !", "Already task added", "warning");
      zChkVal = false;
    } else {

      var zRowLenth = $("#tblTask tbody").find("tr").length;
      var selectedOptions = [];
      $('#ddlJournal option:selected').each(function () {
        selectedOptions.push($(this).text());
      });
      var selectedOptionsText = selectedOptions.join(',');

      var nRowL = "<tr><td style='width:2%;text-align:center'>" + (zRowLenth + 1).toString() + "</td>"
        + "<td style='width:6%'>" + $('#ddlTaskList option:selected').text() + "</td>"
        + "<td style='width:6%'>" + selectedOptionsText + "</td>"
        + "<td style='width:6%'>" + $('#ddlPriceType option:selected').text() + "</td>"
        + "<td><input type='text' class='form-control IsNumeric AP' value='0'/></td>"
        + "<td><input type='text' class='form-control IsNumeric AC' value='0'/></td>"
        + "<td><input type='text' class='form-control IsNumeric PP' value='0'/></td>"
        + "<td><input type='text' class='form-control IsNumeric PC' value='0'/></td>"
        + "<td><input type='text' class='form-control IsNumeric WP' value='0'/></td>"
        + "<td><input type='text' class='form-control IsNumeric WC' value='0'/></td>"
        + "<td><input type='text' class='form-control IsNumeric TP' value='0'/></td>"
        + "<td><input type='text' class='form-control IsNumeric TC' value='0'/></td>"
        + "<td><input type='text' class='form-control IsNumeric FP' value='0'/></td>"
        + "<td><input type='text' class='form-control IsNumeric FC' value='0'/></td>"
        + "<td width='8%' style='text-align:center'><i class='bx bxs-trash DeleteTaskRow' style='color: #f46a6a; font-size: 20px;cursor:Pointer;'></i></td>"
        + "</tr>";
      $("#tblTask tbody").append(nRowL);

      $('#ddlTaskList').val(-1).change();

      this.ResetTaskPriceFilter();
    }
    $('.DeleteTaskRow').click(function () {
      $(this).closest("tr").remove();
      $("table#tblTask tbody").each(function () {
        $(this).children().each(function (index) {
          $(this).find("td").first().html((index + 1).toString());
        });
      });
    });

    $("input.IsNumeric").keydown(function (e) {
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 || (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) || (e.keyCode >= 35 && e.keyCode <= 40)) {
        return;
      }
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
      }
    });

  }


  //Get all Vendor List
  GetVendorList(): void {
    $("#LoadingImage").show();
    let npublisherId = localStorage.aPubID;
    ApiMethod.getMethod(this.modelItem.VendorListAPI + localStorage.aLoginID + '/' + npublisherId).subscribe(
      result => {
        $("#LoadingImage").hide();

        this.dataSet = JSON.stringify(result.aitemList); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let acolList = result.acolListL;

        let dataItem = new DataParam();
        dataItem.acolList = acolList;
        dataItem.aNewButtonName = 'btn_Add';
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 200);
        dataItem.modulename = 'VendorModule';
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });

  }

  GetJournalList(): void {

    var publisher = $("#ddlPublisherList").val().toString();
    if (publisher == "") {
      publisher = localStorage.aPubID;
    }

    ApiMethod.getMethod(this.modelItem.JournalListAPI + '/' + publisher).subscribe(
      result => {
        this.journalList = result.aJournalList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Show Vendor details by ID
  showVendor(): void {
    this.ClearData();

    if (localStorage.aEID != 0) {

      $("#LoadingImagePopup").show();
      $('#imgProfile').attr('src', '../../../assets/Images/userLogo.jpg');
      $("#imageUploadForm").val(null);

      ApiMethod.getMethod(this.modelItem.VendorByIDAPI + localStorage.aEID).subscribe(
        result => {

          $("#LoadingImagePopup").hide();
          let aitems = result.aList;

          console.log(aitems);
          //Populate Primary Data
          
          $('#Txt_Name').val(aitems[0].VendorName);
          $('#Txt_EmailID').val(aitems[0].EmailID);
          $('#Txt_AltEmailID').val(aitems[0].AlternateEmailID);
          $('#Txt_Supplier').val(aitems[0].SuplierId);
          $("#ddlActive").val(aitems[0].ActiveStatus).change();
          $("#ddlAvaliable").val(aitems[0].Available).change();
          if (aitems[0].FromDate != null) {
            $("#Txt_From").val(GlobalConstants.SetValue_FormatDate(aitems[0].FromDate));
          }
          if (aitems[0].ToDate != null) {
            $("#Txt_To").val(GlobalConstants.SetValue_FormatDate(aitems[0].ToDate));
          }
          $("#ddlvendortype").val(aitems[0].VendorType).change();
          $('#Txt_Capacity').val(aitems[0].Capacity);
          $('#ddlCapacityMode').val(aitems[0].CapacityMode).change();
          $('#ddlCapacityUnit').val(aitems[0].CapacityUnitType).change();
          $('#Txt_TeamID').val(aitems[0].MicrosoftTeamId);

          $('#TXT_Remarks').val(aitems[0].Remarks);

          $('#ConvertionInNT').prop('checked', aitems[0].ConvertionInNT);
          $('#QAVendorRequired').prop('checked', aitems[0].QAVendorRequired);
          $('#JournalWisecapacity').prop('checked', aitems[0].JournalWiseCapacity);
          
          if (aitems[0].PublisherID != null) {
            var data = aitems[0].PublisherID.split(',');
          } else
            data = null;
          var selectedValues = new Array();
          try {
            for (var i = 0; i < data.length; i++) {
              selectedValues[i] = data[i];
            }
          } catch (e) {
          }
          $('#ddlPublisherList').val(selectedValues).change();




          //Source
          if (aitems[0].Source != null) {
            var data = aitems[0].Source.split(',');
          } else
            data = null;
          var selectedValues = new Array();
          try {
            for (var i = 0; i < data.length; i++) {
              selectedValues[i] = data[i];
            }
          } catch (e) {
          }
          $('#ddlSourceList').val(selectedValues).change();
          //Language
          if (aitems[0].Languages != null) {
            data = aitems[0].Languages.split(',');
          } else
            data = null;
          selectedValues = new Array();
          try {
            for (var i = 0; i < data.length; i++) {
              selectedValues[i] = data[i];
            }
          } catch (e) {
          }
          $('#ddlLanguageList').val(selectedValues).change();
          //Interest
          if (aitems[0].Interest != null) {
            data = aitems[0].Interest.split(',');
          } else
            data = null;
          selectedValues = new Array();
          try {
            for (var i = 0; i < data.length; i++) {
              selectedValues[i] = data[i];
            }
          } catch (e) {
          }
          $('#ddlInterestList').val(selectedValues).change();
          //Restriction
          if (aitems[0].Restriction != null) {
            data = aitems[0].Restriction.split(',');
          } else
            data = null;
          selectedValues = new Array();
          try {
            for (var i = 0; i < data.length; i++) {
              selectedValues[i] = data[i];
            }
          } catch (e) {
          }
          $('#ddlRestrictionList').val(selectedValues).change();
          //JournalList
          if (aitems[0].JournalList != null) {
            data = aitems[0].JournalList.split(',');
          } else
            data = null;
          selectedValues = new Array();
          try {
            for (var i = 0; i < data.length; i++) {
              selectedValues[i] = data[i];
            }
          } catch (e) {
          }
          $('#ddlJournalList').val(selectedValues).change();

          //JournalListService
          if (aitems[0].JournalList != null) {
            data = aitems[0].JournalList.split(',');
          } else
            data = null;
          selectedValues = new Array();
          try {
            for (var i = 0; i < data.length; i++) {
              selectedValues[i] = data[i];
            }
          } catch (e) {
          }
          $('#ddlJournalListService').val(selectedValues).change();
          //Populate  Personnel Data
          $('#Txt_mobile').val(aitems[0].ContactNo);
          if (aitems[0].DOB != null) {
            $("#Txt_DOB").val(GlobalConstants.SetValue_FormatDate(aitems[0].DOB));
          }
          $('#Txt_fascimile').val(aitems[0].Facsimile);
          $('#ddlGender').val(aitems[0].Gender).change();
          $('#Txt_address').val(aitems[0].Address);
          $('#Txt_pincode').val(aitems[0].ZIPPostCode);
          $('#Txt_Webaddress').val(aitems[0].WebAddress);
          $('#Txt_weblink').val(aitems[0].WebLink);
          $('#ddlCountry').val(aitems[0].Country).change();
          if ($('#ddlCountry').val() != null) {
            this.GetState(aitems[0].StateProvince, aitems[0].City);
          }
          //Bank details
          $('#Txt_BankName').val(aitems[0].BankName);
          $('#Txt_AccNo').val(aitems[0].AccountNo);
          $('#Txt_IFSC').val(aitems[0].IFSCCode);
          $('#Txt_Branch').val(aitems[0].BranchName);
          $('#ddlNDAdoc').val(aitems[0].NDADocument).change();
          $('#Txt_PAN').val(aitems[0].PANCard);
          


          if (aitems[0].Image == null)
            $('#imgProfile').attr('src', '../../../assets/Images/userLogo.jpg');
          else
            $('#imgProfile').attr('src', aitems[0].Image);


          //Populate Task List
          $("#tblTask tbody").html("");
          let aTaskListL = result.aTaskList;
          console.log(aTaskListL);
          $.each(aTaskListL, function (e, val) {

            var zRowLenth = $("#tblTask tbody").find("tr").length;
            var nRowL = "<tr><td style='width:2%;text-align:center'>" + (zRowLenth + 1).toString() + "</td>"
              + "<td style='width:6%'>" + val.TaskName + "</td>"
              + "<td style='width:6%'>" + val.Journals + "</td>"
              + "<td style='width:6%'>" + val.PriceType + "</td>"
              + "<td><input type='text' class='form-control IsNumeric AP' value='" + val.ArticlePrice + "'/></td>"
              + "<td><input type='text' class='form-control IsNumeric AC' value='" + val.ArticleCapacity + "'/></td>"
              + "<td><input type='text'  class='form-control IsNumeric PP' value='" + val.Price + "'/></td>"
              + "<td><input type='text' class='form-control IsNumeric PC' value='" + val.Capacity + "'/></td>"
              + "<td><input type='text' class='form-control IsNumeric WP' value='" + val.WordPrice + "'/></td>"
              + "<td><input type='text' class='form-control IsNumeric WC' value='" + val.WordCapacity + "'/></td>"
              + "<td><input type='text' class='form-control IsNumeric TP' value='" + val.TablePrice + "'/></td>"
              + "<td><input type='text' class='form-control IsNumeric TC' value='" + val.TableCapacity + "'/></td>"
              + "<td><input type='text' class='form-control IsNumeric FP' value='" + val.FigurePrice + "'/></td>"
              + "<td><input type='text' class='form-control IsNumeric FC' value='" + val.FigureCapacity + "'/></td>"
              + "<td width='8%' style='text-align:center'><i class='bx bxs-trash DeleteTaskRow' style='color: #f46a6a; font-size: 20px;cursor:Pointer;'></i></td>"
              + "</tr>";
            $("#tblTask tbody").append(nRowL);
          });

          $('.DeleteTaskRow').click(function () {
            $(this).closest("tr").remove();
            $("table#tblTask tbody").each(function () {
              $(this).children().each(function (index) {
                $(this).find("td").first().html((index + 1).toString());
              });
            });
          });


          $("#tblTaskSer tbody").html("");
          let aTaskSerL = result.ServiceList;        

          $.each(aTaskSerL, function (e, val) {
            console.log(val.TaskName);
            var zRowLenth = $("#tblTaskSer tbody").find("tr").length;
            var nRowS = "<tr><td style='width:2%;text-align:center'>" + (zRowLenth + 1).toString() + "</td>"
              + "<td style='width:6%'>" + val.TaskName + "</td>"
              + "<td style='width:6%'>" + val.Journals + "</td>"
              + "<td style='width:6%'>" + val.VendorType + "</td>"
              + "<td style='width:6%'>" + val.Languages + "</td>"
              + "<td style='width:6%'>" + val.Sources + "</td>"
              + "<td><input type='text' class='form-control IsNumeric CC' value='" + val.Capacity + "'/></td>"
              + "<td><input type='text' class='form-control IsNumeric CU' value='" + val.CapacityUnitType + "'/></td>"
              + "<td><input type='text'  class='form-control IsNumeric CM' value='" + val.CapacityMode + "'/></td>"
              + "<td width='8%' style='text-align:center'><i class='bx bxs-trash DeleteTaskSerRow' style='color: #f46a6a; font-size: 20px;cursor:Pointer;'></i></td>"
              + "</tr>";
            $("#tblTaskSer tbody").append(nRowS);
          });

          $('.DeleteTaskSerRow').click(function () {
            $(this).closest("tr").remove();
            $("table#tblTaskSer tbody").each(function () {
              $(this).children().each(function (index) {
                $(this).find("td").first().html((index + 1).toString());
              });
            });
          });
          //Disable Table values          
          const event = { target: { checked: aitems[0].JournalWiseCapacity } };
          this.disableTableFields(event);

          $("input.IsNumeric").keydown(function (e) {
            if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
              (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
              (e.keyCode >= 35 && e.keyCode <= 40)) {
              return;
            }
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
              e.preventDefault();
            }
          });
        },
        error => {
          ngswal("Failed !", error.error.Message, "warning");
        }
      );

      this.title = "Update Vendor Details"; // Dynamic Data
      this.popUpButtonText = "Update";
    } else {

      this.title = "New Vendor Details"; // Dynamic Data
      $("#ddlActive").val('Active').change();
      $("#ddlAvaliable").val('Yes').change();
      this.popUpButtonText = "Save";
    }
    $("input.IsNumeric").keydown(function (e) {
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 || (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) || (e.keyCode >= 35 && e.keyCode <= 40)) {
        return;
      }
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
      }
    });
    this.showModal = true; // Show-Hide Modal Check
  }

  //disable table fields service
  disableTableFields(event: any) {
    const checkbox = event.target as HTMLInputElement;
    const checkboxValue = checkbox.checked;
    if (checkboxValue === false) {
      $("#tblTaskSer input[type='text']").prop('disabled', true);
    } else {
      $("#tblTaskSer input[type='text']").prop('disabled', false);
    }
  
  }


  // Add/Update Vendor details
  AddUpdateVendor(): void {
    var getTaskList = GlobalConstants.GetTableRowToList('tblTask', null);
    var getServicelist = GlobalConstants.GetTableRowToList('tblTaskSer', null);
    console.log(getTaskList);
    if ($('#Txt_Name').val().trim() == '') {
      ngswal("Warning !", "Enter Vendor name!", "warning");
    }
    else if ($('#ddlActive').val() == null) {
      ngswal("Warning !", "Select active status!", "warning");
    }
    else if ($('#Txt_EmailID').val().trim() == '') {

      ngswal("Warning !", "Enter EmailID!", "warning");
    }
    else if ($('#ddlAvaliable').val() == null) {

      ngswal("Warning !", "Select Available!", "warning");
    }
    else if ($('#ddlAvaliable').val() == 'No') {

      if ($('#Txt_From').val() == '' && $('#Txt_To').val() == '') {
        ngswal("Warning !", "Enter From/To date!", "warning");
      }

    }
 
    else {
      $("#LoadingImagePopup").show();

      var vendorData = {
        ID: localStorage.aEID,
        PublisherID: localStorage.aPubID,
        VendorName: $('#Txt_Name').val(),
        EmailID: $('#Txt_EmailID').val(),
        AlternateEmailID: $('#Txt_AltEmailID').val(),
        SuplierId: $('#Txt_Supplier').val(),
        ActiveStatus: $('#ddlActive').val(),
        Available: $('#ddlAvaliable').val(),
        FromDate: $('#Txt_From').val(),
        ToDate: $('#Txt_To').val(),
        VendorType: $('#ddlvendortype').val(),
        Languages: $('#ddlLanguageList').val().toString(),
        Source: $('#ddlSourceList').val().toString(),
        Interest: $('#ddlInterestList').val().toString(),
        Restriction: $('#ddlRestrictionList').val().toString(),
        Capacity: $('#Txt_Capacity').val(),
        CapacityMode: $('#ddlCapacityMode').val(),
        CapacityUnitType: $('#ddlCapacityUnit').val(),
        Remarks: $('#TXT_Remarks').val(),
        ConvertionInNT: $('#ConvertionInNT').prop('checked'),
        QAVendorRequired: $('#QAVendorRequired').prop('checked'),
        JournalWisecapacity: $('#JournalWisecapacity').prop('checked'),
        BankName: $('#Txt_BankName').val(),
        AccountNo: $('#Txt_AccNo').val(),
        IFSCCode: $('#Txt_IFSC').val(),
        BranchName: $('#Txt_Branch').val(),
        NDADocument: $('#ddlNDAdoc').val(),
        PANCard: $('#Txt_PAN').val(),
        ContactNo: $('#Txt_mobile').val(),
        DOB: $('#Txt_DOB').val(),
        Gender: $('#ddlGender').val(),
        Facsimile: $('#Txt_fascimile').val(),
        Address: $('#Txt_address').val(),
        ZIPPostCode: $('#Txt_pincode').val(),
        WebLink: $('#Txt_weblink').val(),
        Country: $('#ddlCountry').val(),
        StateProvince: $('#ddlState').val(),
        City: $('#ddlCity').val(),
        WebAddress: $('#Txt_Webaddress').val(),
        Image: $('#imgProfile').attr('src'),
        MicrosoftTeamId: $('#Txt_TeamID').val(),
       /* PublisherID: $('#ddlPublisherList').val().toString(),*/
        JournalList: $('#ddlJournalList').val().toString(),
        TaskList: JSON.stringify(getTaskList),
        Servicelist: JSON.stringify(getServicelist),
        UpdatedBy: localStorage.aLoginID
        //Country: ($('#ddlCountry').val() == null ? null : $('#ddlState').val().toString()),
        //StateProvince: ($('#ddlState').val() == null ? null : $('#ddlState').val().toString()),
        //City: ($('#ddlCity').val() == null ? null : $('#ddlCity').val().toString()),
      };
      console.log(vendorData);
      //add publish id
      ApiMethod.postMethod(this.modelItem.UpdateAPI, vendorData).subscribe(
        resonse => {
          this.GetVendorList();
          $("#LoadingImagePopup").hide();
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Thank You !",
            text: resonse,
            showConfirmButton: false,
            timer: 1500
          });
          this.hide();
        },
        error => {
          ngswal("Failed!", error.error.Message, "error");
          $("#LoadingImagePopup").hide();
        }
      );
    }
  }

  hide(): void {
    this.showModal = false;
    this.ClearData();
  }



  //Clear all data
  ClearData(): void {
    //All Clear
    $("input[type='text']").val("");
    $("input[type='number']").val("");
    $("input[type='email']").val("");
    $("input[type='date']").val("");
    $("input[type='checkbox']").prop("checked", false);
    $("textarea").val("");

    //DDl CLear
    $("#ddlCountry").val(0).change();
    $("#ddlState").val(0).change();
    $("#ddlCity").val(0).change();
    $("#ddlJournalType").val(0).change();
    $("#ddlAvaliable").val(0).change();
    $("#ddlPublisherList").val(0).change();
    $("#ddlSourceList").val(0).change();
    $("#ddlInterestList").val(0).change();
    $("#ddlRestrictionList").val(0).change();
    $("#ddlJournalList").val(0).change();
    $("#ddlPriceType").val(0).change();
    $("#ddlCapacityMode").val(0).change();
    $("#ddlCapacityUnit").val(0).change();
    $("#ddlLanguageListSer").val(0).change();
    $("#ddlSourceListSer").val(0).change();
    $("#ddlLanguageList").val(0).change();
    $('#ddlNDAdoc').val(0).change();
    //Table row clear
    $("#tblTask tbody").html("");
    $("#tblTaskSer tbody").html("");

    //when close active primarytab
    $('a[href="#divPrimary"]').click();
    //Image clear
    $('#imgProfile').attr('src', '../../../assets/Images/userLogo.jpg');
    $("#imageUploadForm").val(null);
    //Table's Filter clear
    this.ResetTaskPriceFilter();
    this.ResetServicesFilter();
  }

  //clear all data TaskPrice
  ResetTaskPriceFilter(): void {
    $("#ddlTaskList").val(0).change();
    $("#ddlJournal").val(0).change();
    $("#ddlPriceType").val(0).change();
  }

  //clear all data TaskDetails
  ResetServicesFilter(): void {
    $("#ddlTaskListser").val(0).change();
    $("#ddlJournalListService").val(0).change();
    $("#ddlLanguageListSer").val(0).change();
    $("#ddlSourceListSer").val(0).change();
    $("#ddlvendortype").val(0).change();

  }


  //DOB validation
  Dobdatevalidation(event) {
    var x = new Date($("#Txt_DOB").val());
    var Cnow = new Date();
    if ($("#Txt_DOB").val() == "") {
      $("#Txt_DOB").focus();
    }
    else if (Cnow.getFullYear() - x.getFullYear() < 18) {
      ngswal("Failed !", "DOB Not Valid", "warning");

    }
  }

  //Image Upload
  showPreview(event) {
    var ext = $('#imageUploadForm').val().split('.').pop().toLowerCase();
    if ($.inArray(ext, ['png', 'jpg', 'jpeg']) == -1) {
      ngswal("Failed !", "Invalid Image format", "warning");
      return false;
    }
    else if (event.target.files[0].size > 2000000) {
      ngswal("Failed !", "Please upload photo less than 2MB", "warning");
      return false;
    }

    if (event.target.files[0]) {
      var fileReader = new FileReader();
      fileReader.onload = function (e) {
        $('#imgProfile').attr('src', fileReader.result);
      }
      fileReader.readAsDataURL(event.target.files[0]);

    }
  }

  onerrorImageLoad() {
    var zActHostpath = document.location.pathname.split('/')[1];
    $('#imgProfile').attr('src', '/' + zActHostpath + "../../../assets/Images/userLogo.jpg");
  }
}
